import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAllSubmissions,
  updateSubmission
} from "../utils/submissionUtils";
import { getCurrentUser } from "../utils/auth";
import "../styles/styles.css";

const SubmissionsAdmin = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(getCurrentUser());
  const [submissions, setSubmissions] = useState([]);
  const [refreshFlag, setRefreshFlag] = useState(false);

  useEffect(() => {
    if (user !== "admin@aiveo.com") {
      navigate("/");
    } else {
      setSubmissions(getAllSubmissions());
    }
  }, [user, navigate, refreshFlag]);

  const handleApprove = (pitch) => {
    updateSubmission(pitch.id, {
      status: "approved",
      comments: "Aprobado. El creador puede subir el contenido completo.",
    });
    setRefreshFlag((f) => !f);
  };

  const handleReject = (pitch) => {
    const feedback = window.prompt("Ingresa el motivo de rechazo o feedback:", pitch.comments);
    if (feedback !== null) {
      updateSubmission(pitch.id, { status: "rejected", comments: feedback });
      setRefreshFlag((f) => !f);
    }
  };

  const handleView = (pitch) => {
    alert(
      `Título: ${pitch.title}\nUsuario: ${pitch.submittedBy}\nFecha: ${new Date(
        pitch.submittedAt
      ).toLocaleString()}\nGéneros: ${pitch.genres.join(", ")}\n\nSinopsis:\n${pitch.synopsis}`
    );
  };

  return (
    <div className="admin-container">
      <h2>Administración de Pitches (IA Creators)</h2>
      {submissions.length === 0 ? (
        <p style={{ color: "var(--color-text-secondary)" }}>No hay propuestas pendientes.</p>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>Título</th>
              <th>Usuario</th>
              <th>Fecha</th>
              <th>Géneros</th>
              <th>Estado</th>
              <th>Comentarios</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {submissions.map((pitch) => (
              <tr key={pitch.id}>
                <td>{pitch.title}</td>
                <td>{pitch.submittedBy}</td>
                <td>{new Date(pitch.submittedAt).toLocaleDateString()}</td>
                <td>{pitch.genres.join(", ")}</td>
                <td>{pitch.status}</td>
                <td>{pitch.comments}</td>
                <td>
                  <button
                    className="btn-small"
                    onClick={() => handleView(pitch)}
                  >
                    Ver
                  </button>
                  {pitch.status === "pending" && (
                    <>
                      <button
                        className="btn-small btn-approve"
                        onClick={() => handleApprove(pitch)}
                      >
                        Aprobar
                      </button>
                      <button
                        className="btn-small btn-reject"
                        onClick={() => handleReject(pitch)}
                      >
                        Rechazar
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default SubmissionsAdmin;